
































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import { PasswordInput } from '@/common/auth';
import { ErrorMessage } from '@/common/errors';
import { UserStore } from '@/store/user';

@Component({
  components: {
    ErrorMessage,
    PasswordInput,
  },
})
export default class LoginInitialPassword extends Vue {
  @Prop() username!: string;

  credentials = { oldPassword: '', newPassword: '', confirmPassword: '' };
  error = null;
  isSubmitting = false;
  @UserStore.Bind.Action setInitialPassword!: UserStore.Action<'setInitialPassword'>;

  get isDisabled() {
    return this.isSubmitting ||
           !this.credentials.oldPassword.length ||
           !this.credentials.newPassword.length ||
           !this.credentials.confirmPassword.length ||
           (this.credentials.newPassword !== this.credentials.confirmPassword);
  }

  @Emit() cancel() { }

  async submit() {
    this.error = null;
    this.isSubmitting = true;
    const credentials = { ...this.credentials, username: this.username };

    try {
      await this.setInitialPassword(credentials);
      this.$emit('success');
    }
    catch (error) {
      this.error = error;
    }
    finally {
      this.isSubmitting = false;
    }
  }
}
